import React from 'react';
import './ApplicationModal.css';

function ApplicationModal({ application, onClose }) {
  if (!application) return null;

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Get application type label
  const getTypeLabel = (type) => {
    switch (type) {
      case 'artist': return 'Music Artist';
      case 'media': return 'Media Outlet';
      case 'brand': return 'Brand Partner';
      default: return type;
    }
  };

  return (
    <div className="application-modal-overlay" onClick={onClose}>
      <div className="application-modal" onClick={(e) => e.stopPropagation()}>
        <div className="application-modal__header">
          <h2>Application Details</h2>
          <button className="application-modal__close" onClick={onClose}>×</button>
        </div>
        
        <div className="application-modal__content">
          <div className="application-modal__field">
            <span className="application-modal__label">Type:</span>
            <span className={`application-modal__type type-${application.type}`}>
              {getTypeLabel(application.type)}
            </span>
          </div>
          
          <div className="application-modal__field">
            <span className="application-modal__label">Name:</span>
            <span className="application-modal__value">{application.name}</span>
          </div>
          
          <div className="application-modal__field">
            <span className="application-modal__label">Email:</span>
            <a 
              href={`mailto:${application.email}`} 
              className="application-modal__value application-modal__link"
            >
              {application.email}
            </a>
          </div>
          
          {application.link && (
            <div className="application-modal__field">
              <span className="application-modal__label">Link:</span>
              <a 
                href={application.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="application-modal__value application-modal__link"
              >
                {application.link}
              </a>
            </div>
          )}
          
          <div className="application-modal__field">
            <span className="application-modal__label">Submitted:</span>
            <span className="application-modal__value">{formatDate(application.createdAt)}</span>
          </div>
          
          <div className="application-modal__field application-modal__message">
            <span className="application-modal__label">Message:</span>
            <div className="application-modal__message-content">
              {application.message}
            </div>
          </div>
        </div>
        
        <div className="application-modal__footer">
          <button 
            className="application-modal__button application-modal__button--primary"
            onClick={onClose}
          >
            Close
          </button>
          <a 
            href={`mailto:${application.email}?subject=Re: Your application to Northstar`}
            className="application-modal__button application-modal__button--secondary"
          >
            Reply via Email
          </a>
        </div>
      </div>
    </div>
  );
}

export default ApplicationModal; 